import React from 'react';
import { Handle, Position } from 'reactflow';
import './nodes.css';

// Placeholder: mostra un riassunto in sola lettura. L'editing del bracket arriva nel sotto-progetto #2.
// I dati interni (internalMatches, mapping, ecc.) restano in data e vengono preservati nel salvataggio.
const DiretteNode = ({ data, selected }) => (
  <div className={`fnode fnode--dirette ${selected ? 'is-selected' : ''}`}>
    <Handle type="target" position={Position.Left} />
    <div className="fnode__badge">Eliminazione</div>
    <div className="fnode__title">{data.name || 'Dirette'}</div>
    <div className="fnode__sub">
      Fascia {data.fascia ?? 1} · {(data.internalMatches || []).length} match
    </div>
    <Handle type="source" position={Position.Right} />
  </div>
);

export default DiretteNode;
